import { tween } from '../animations/defaultAnimations'

export const dropdown = {
  collapsed: {
    height: '0px',
    transition: tween,
  },
  exit: {
    height: '0px',
    transition: tween,
  },
  open: {
    height: 'auto',
    transition: tween,
  },
}

export const sideBar ={
  collapsed: {
    width: '0px',
    transition: tween,
  },
  exit: {
    width: '0px',
    transition: tween,
  },
  open: {
    duration: 0.2,
    width: 'max-content',
    transition: tween
  }
}

// export default dropdown
